import AddAppointment from "components/appointment/AddAppointment";
import { usePermissions } from "layouts/Admin";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Navbar } from "reactstrap";
import { appointmentsSelector } from "slices/appointmentSlice";
import { closeAppointmentPopup, setAddAppointmentPopup } from "slices/appointmentSlice";
import { fetchDashboardAnalytics, fetchDashboardAppointments } from "slices/dashboardSlice";
import { useTranslation } from "react-i18next";
// ✅ Import the new component
import CheckInButton from "components/common/CheckInButton";
import { logout, userSelector } from "slices/userSlice";

function Header(props) {
  const { user } = useSelector(userSelector);
  const checkinStatus = Number(user?.checked_in ?? user?.user?.checked_in) === 1 ? 1 : 0;
  const role = user?.role ?? user?.user?.role;
  const [color] = React.useState("transparent");
  const [dropdownOpen, setDropdownOpen] = React.useState(false);
  const [languageDropdownOpen, setLanguageDropdownOpen] = React.useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { checkPermission } = usePermissions();
  const { popup: appointmentPopUpState } = useSelector(appointmentsSelector);
  const refDropdown = React.useRef(null);
  const languageDropdownRef = React.useRef(null);
  const { t, i18n } = useTranslation();
  const languageOptions = [
    {
      code: "en",
      label: "English",
    },
    {
      code: "es",
      label: "Spanish",
    },
  ];

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (refDropdown.current && !refDropdown.current.contains(event.target)) {
        setDropdownOpen(false);
      }
      if (
        languageDropdownRef.current &&
        !languageDropdownRef.current.contains(event.target)
      ) {
        setLanguageDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Close dropdown on route change
  useEffect(() => {
    setDropdownOpen(false);
  }, [location]);

  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);
  const toggleLanguageDropdown = () => setLanguageDropdownOpen((prev) => !prev);

  const handleLanguageChange = (code) => {
    i18n.changeLanguage(code);
    setLanguageDropdownOpen(false);
  };

  const handleLogout = () => {
    dispatch(logout());
    navigate("/login", { replace: true });
  };

  const handleClose = () => dispatch(closeAppointmentPopup());

  const callback = () => {
    handleClose();
    appointmentPopUpState?.callback && appointmentPopUpState?.callback();
    dispatch(fetchDashboardAnalytics());
    dispatch(fetchDashboardAppointments());
  };

  const handleAddAppointmentPopUp = (item) => {
    dispatch(setAddAppointmentPopup({ show: true, item }));
  };

  const isTranslationRoute = location.pathname.indexOf("/translation") !== -1;
  const handleNewProjectClick = () => {
    navigate("/translation/create");
  };

  console.log('sadsasasadd', user);
  return (
    <>
      <AddAppointment
        item={appointmentPopUpState.item}
        show={appointmentPopUpState.show}
        onClose={handleClose}
        callback={callback}
        popupType={appointmentPopUpState.popupType}
      />

      <Navbar
        expand="lg"
        className={
          location.pathname.indexOf("full-screen-maps") !== -1
            ? "navbar-absolute border-0 fixed-top"
            : "navbar-absolute border-0 fixed-top " +
            (color === "transparent" ? "navbar-transparent " : "")
        }
      >
        <div className="header">
          <button className="toggle_sidebar" onClick={props.toggleSidebar}>
            <img src="/images/ham.png" alt="" />
          </button>
          <div className="row_user_side">
            <CheckInButton
              initialCheckedIn={checkinStatus}
              role={role}
              internalInterpreter={user?.internal_interpreter ?? user?.user?.internal_interpreter}
            />

            {isTranslationRoute ? (
            checkPermission("Add Appointments") && (
                <button
                  className="main_button"
                  onClick={handleNewProjectClick}
                  type="button"
                >
                  {t("header.newProject")}
                </button>
              )
            ) : (
            // {checkPermission("Add Appointments") && (
            (
              <button
                className="main_button"
                onClick={() => handleAddAppointmentPopUp()}
                type="button"
              >
                {t("header.newAppointment")}
              </button>
              )
            // )}
            )}

            <div
              ref={languageDropdownRef}
              className="d-flex align-items-center gap-2 position-relative"
            >
              <button
                className="drop_icon language_switcher_trigger"
                onClick={toggleLanguageDropdown}
                type="button"
                aria-label={t("header.languageSwitcherLabel")}
                title={t("header.languageSwitcherLabel")}
              >
                <i class="fa fa-globe"></i>
                <span className="language_switcher_value">
                  {languageOptions.find((option) =>
                    i18n.language?.startsWith(option.code)
                  )?.label ?? "English"}
                </span>
                <i class="fa fa-chevron-down"></i>
              </button>

              <div
                className={`drop_more_selector language_switcher_dropdown ${
                  languageDropdownOpen ? "language_active" : ""
                }`}
              >
                <div className="language_switcher_header">Select Language</div>

                <div className="language_switcher_list">
                  {languageOptions.map((option) => {
                    const isActive = i18n.language?.startsWith(option.code);

                    return (
                      <button
                        type="button"
                        key={option.code}
                        className={`language_switcher_option ${
                          isActive ? "language_switcher_option_active" : ""
                        }`}
                        onClick={() => handleLanguageChange(option.code)}
                      >
                        <span className="language_switcher_option_left">
                          <span className="language_switcher_label">
                            {option.label}
                          </span>
                        </span>

                        {isActive && (
                          <span className="language_switcher_check" aria-hidden="true">
                            ✓
                          </span>
                        )}
                      </button>
                    );
                  })}
                </div>
              </div>
            </div>

            <div ref={refDropdown} className="d-flex align-items-center gap-2 position-relative">
              <button className="user_image" onClick={toggleDropdown}>
                <img src="/images/default-person.png" alt="" />
                <span></span>
              </button>

              <button
                className={`drop_icon ${dropdownOpen ? "active" : ""}`}
                onClick={toggleDropdown}
              >
                <img src="/images/drop.png" alt="" />
              </button>

              <div
                className={`drop_more_selector ${dropdownOpen ? "active" : ""}`}
              >
                <ul>
                  <li>
                    <Link href="#!">{t("header.profile")}</Link>
                  </li>
                  {checkPermission("Change Password") && (
                    <li>
                      <Link to="/change-password">{t("header.changePassword")}</Link>
                    </li>
                  )}
                  <li>
                    <Link href="#!">{t("header.help")}</Link>
                  </li>
                  <li>
                    <a href="" onClick={handleLogout} className="red_clr">
                      {t("header.logout")}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </Navbar>
    </>
  );
}

export default Header;
